/**
 * Form Select Search - searchable dropdown behavior.
 * Initializes all .js-form-select-search on the page. Reusable for assessment and contact forms.
 */
(function() {
	'use strict';

	function init(container) {
		if (!container || container.getAttribute('data-form-select-search-inited') === '1') return;
		container.setAttribute('data-form-select-search-inited', '1');

		var trigger = container.querySelector('.form-select-search__trigger');
		var hiddenInput = container.querySelector('input[type="hidden"]');
		var dropdown = container.querySelector('.form-select-search__dropdown');
		var searchInput = container.querySelector('.form-select-search__search');
		var list = container.querySelector('.form-select-search__list');
		var displayEl = container.querySelector('.form-select-search__display');
		var options = list ? list.querySelectorAll('.form-select-search__option') : [];

		var placeholder = trigger && trigger.querySelector('.form-select-search__display') ? (trigger.querySelector('.form-select-search__display').getAttribute('data-placeholder') || 'Select...') : 'Select...';

		function getDisplayText() {
			var val = hiddenInput ? hiddenInput.value : '';
			for (var i = 0; i < options.length; i++) {
				if (options[i].getAttribute('data-value') === val) return options[i].textContent.trim();
			}
			return '';
		}

		function open() {
			container.classList.add('is-open');
			if (dropdown) {
				dropdown.classList.remove('hidden');
				dropdown.setAttribute('aria-hidden', 'false');
			}
			if (trigger) trigger.setAttribute('aria-expanded', 'true');
			if (searchInput) {
				searchInput.value = '';
				searchInput.focus();
				filterOptions('');
			}
		}

		function close() {
			container.classList.remove('is-open');
			if (dropdown) {
				dropdown.classList.add('hidden');
				dropdown.setAttribute('aria-hidden', 'true');
			}
			if (trigger) trigger.setAttribute('aria-expanded', 'false');
		}

		function getVisibleOptions() {
			var visible = [];
			for (var i = 0; i < options.length; i++) {
				if (options[i].style.display !== 'none') visible.push(options[i]);
			}
			return visible;
		}

		function focusOption(opt) {
			if (!opt) return;
			opt.focus();
			try {
				opt.scrollIntoView({ block: 'nearest' });
			} catch (err) {
				opt.scrollIntoView(false);
			}
		}

		function filterOptions(q) {
			q = (q || '').toLowerCase().trim();
			var visible = 0;
			for (var i = 0; i < options.length; i++) {
				var text = options[i].textContent.trim().toLowerCase();
				var show = !q || text.indexOf(q) !== -1;
				options[i].style.display = show ? '' : 'none';
				if (show) visible++;
			}
		}

		function selectOption(opt) {
			var val = opt.getAttribute('data-value');
			if (hiddenInput) {
				hiddenInput.value = val;
				hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
			}
			if (displayEl) {
				displayEl.textContent = val ? opt.textContent.trim() : (displayEl.getAttribute('data-placeholder') || 'Select...');
			}
			list.querySelectorAll('.form-select-search__option').forEach(function(o) {
				o.classList.remove('bg-primary-50', 'text-primary-800');
				o.removeAttribute('aria-selected');
				if (o.getAttribute('data-value') === val) {
					o.classList.add('bg-primary-50', 'text-primary-800');
					o.setAttribute('aria-selected', 'true');
				}
			});
			close();
		}

		if (trigger) {
			trigger.addEventListener('click', function(e) {
				e.preventDefault();
				if (container.classList.contains('is-open')) close(); else open();
			});
		}

		if (searchInput) {
			searchInput.addEventListener('input', function() {
				filterOptions(searchInput.value);
			});
			searchInput.addEventListener('keydown', function(e) {
				if (e.key === 'Escape') {
					close();
					if (trigger) trigger.focus();
					return;
				}
				var visible = getVisibleOptions();
				if (e.key === 'Enter') {
					if (visible.length === 1) {
						e.preventDefault();
						selectOption(visible[0]);
					} else if (visible.length > 1) {
						e.preventDefault();
						focusOption(visible[0]);
					}
					return;
				}
				if (e.key === 'ArrowDown') {
					e.preventDefault();
					if (visible.length) focusOption(visible[0]);
					return;
				}
				if (e.key === 'ArrowUp') {
					e.preventDefault();
					if (visible.length) focusOption(visible[visible.length - 1]);
					return;
				}
			});
		}

		list && options.forEach(function(opt) {
			opt.addEventListener('click', function() {
				selectOption(opt);
			});
			opt.addEventListener('keydown', function(e) {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					selectOption(opt);
					return;
				}
				if (e.key === 'ArrowDown') {
					e.preventDefault();
					var visible = getVisibleOptions();
					var idx = visible.indexOf(opt);
					if (idx !== -1 && idx < visible.length - 1) focusOption(visible[idx + 1]);
					else if (visible.length) focusOption(visible[0]);
					return;
				}
				if (e.key === 'ArrowUp') {
					e.preventDefault();
					var visible = getVisibleOptions();
					var idx = visible.indexOf(opt);
					if (idx > 0) focusOption(visible[idx - 1]);
					else if (visible.length) focusOption(visible[visible.length - 1]);
					return;
				}
				if (e.key === 'Home') {
					e.preventDefault();
					var vis = getVisibleOptions();
					if (vis.length) focusOption(vis[0]);
					return;
				}
				if (e.key === 'End') {
					e.preventDefault();
					var vis2 = getVisibleOptions();
					if (vis2.length) focusOption(vis2[vis2.length - 1]);
					return;
				}
				if (e.key === 'Escape') {
					e.preventDefault();
					close();
					if (trigger) trigger.focus();
					return;
				}
			});
		});

		document.addEventListener('click', function(e) {
			if (container.classList.contains('is-open') && !container.contains(e.target)) close();
		});
	}

	function run() {
		document.querySelectorAll('.js-form-select-search').forEach(init);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', run);
	} else {
		run();
	}

	// Expose for dynamic content (e.g. forms loaded via AJAX)
	window.canadaAbroadInitFormSelectSearch = function(root) {
		var el = root && root.querySelector ? root : document;
		(el.querySelectorAll ? el.querySelectorAll('.js-form-select-search') : []).forEach(init);
	};
})();
